import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-column-fluid" }
const _hoisted_2 = {
  key: 0,
  class: "card"
}
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = { class: "card-title" }
const _hoisted_5 = { class: "card-body py-4" }
const _hoisted_6 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_7 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "text-center min-w-150px" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]

import { useStore } from "@/store";
import { inject, ref, onMounted } from "vue";
import TableFooter from "@/components/TableFooter.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import UserService from "../services/UserService";
import UserKycForm from "../components/UserKycForm.vue";
import UserAuKycForm from "../components/UserAuKycForm.vue";
import { VerificationStatusTypes } from "@/core/types/VerificationInfos";
import TimeShow from "@/components/TimeShow.vue";
import InjectKeys from "@/core/types/TenantGlobalInjectionKeys";
import { Search } from "@element-plus/icons-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'KycForm',
  setup(__props) {

const store = useStore();

const tenant = ref(store.state.AuthModule.user?.tenancy);

const selectedKYC = ref(false);
const selectedPartyId = ref("-1");

const isLoading = ref(true);
const items = ref(Array<any>());
const isNewAuVerification = ref(false);

const openConfirmModal = inject<(handleConfirm: any) => Promise<void>>(
  InjectKeys.OPEN_CONFIRM_MODAL
);

onMounted(() => {
  fetchData(1);
});
const criteria = ref({
  page: 1,
  size: 20,
  sortField: "updatedOn",
  statuses: [
    VerificationStatusTypes.AwaitingReview,
    VerificationStatusTypes.UnderReview,
  ],
});

const returnTable = () => {
  selectedKYC.value = false;
  isLoading.value = false;
};

const fetchData = async (selectedPage: number) => {
  criteria.value.page = selectedPage;
  isLoading.value = true;
  selectedKYC.value = false;

  try {
    const res = await UserService.queryKycForms(criteria.value);
    items.value = res.data;
    criteria.value = res.criteria;
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoading.value = false;
  }
};

const showUserKycForm = async (_partyId) => {
  isLoading.value = true;

  const userVerification = await UserService.queryVerifications({
    partyId: _partyId,
  });

  await UserService.getVerificationById(userVerification.data[0].id).then(
    (res) => {
      if (!("bg1" in res.financial)) {
        isNewAuVerification.value = true;
      } else {
        isNewAuVerification.value = false;
      }
      selectedPartyId.value = _partyId;
      selectedKYC.value = true;
    }
  );
};

const reset = () => {
  criteria.value.email = null;
  fetchData(1);
};

const deleteUserKycForm = async (_partyId: number) => {
  openConfirmModal?.(() =>
    UserService.rejectKycForm(_partyId)
      .then(() => MsgPrompt.success("KYC Form Rejected"))
      .then(() => fetchData(1))
  );
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_UserInfo = _resolveComponent("UserInfo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!selectedKYC.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _createVNode(_component_el_input, {
                  class: "w-400px",
                  modelValue: criteria.value.email,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((criteria.value.email) = $event)),
                  clearable: true,
                  placeholder: "Email"
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      icon: _unref(Search),
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (fetchData(1)))
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_button, {
                  class: "ms-4",
                  type: "info",
                  plain: "",
                  onClick: reset
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.reset")), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("table", _hoisted_6, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_7, [
                  _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t("fields.client")), 1),
                  _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("fields.updatedOn")), 1),
                  _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
                  _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t("action.action")), 1)
                ])
              ]),
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
                    _createVNode(_component_LoadingRing)
                  ]))
                : (!isLoading.value && items.value.length === 0)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_13, [
                      _createVNode(_component_NoDataBox)
                    ]))
                  : (_openBlock(), _createElementBlock("tbody", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", _hoisted_15, [
                            _createVNode(_component_UserInfo, {
                              url: "#",
                              user: item.user,
                              class: "me-2"
                            }, null, 8, ["user"])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(TimeShow, {
                              "date-iso-string": item.updatedOn
                            }, null, 8, ["date-iso-string"])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(TimeShow, {
                              "date-iso-string": item.createdOn
                            }, null, 8, ["date-iso-string"])
                          ]),
                          _createElementVNode("td", _hoisted_16, [
                            _createElementVNode("button", {
                              class: "btn btn-light btn-primary btn-sm me-3",
                              onClick: ($event: any) => (showUserKycForm(item.partyId))
                            }, _toDisplayString(_ctx.$t("action.view")), 9, _hoisted_17),
                            _createElementVNode("button", {
                              class: "btn btn-light btn-danger btn-sm me-3",
                              onClick: ($event: any) => (deleteUserKycForm(item.partyId))
                            }, _toDisplayString(_ctx.$t("action.delete")), 9, _hoisted_18)
                          ])
                        ]))
                      }), 128))
                    ]))
            ]),
            _createVNode(TableFooter, {
              onPageChange: fetchData,
              criteria: criteria.value
            }, null, 8, ["criteria"])
          ])
        ]))
      : (selectedKYC.value && isNewAuVerification.value)
        ? (_openBlock(), _createBlock(UserAuKycForm, {
            key: 1,
            selectedPartyId: selectedPartyId.value,
            onFetchData: fetchData,
            onReturnTable: returnTable
          }, null, 8, ["selectedPartyId"]))
        : (_openBlock(), _createBlock(UserKycForm, {
            key: 2,
            selectedPartyId: selectedPartyId.value,
            onFetchData: fetchData,
            onReturnTable: returnTable
          }, null, 8, ["selectedPartyId"]))
  ]))
}
}

})